import { Button, Form, Modal } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataRequestAction } from "../../redux/actions/CommonHttp";

const AddFormModal = ({
  form,
  children,
  modalTitle,
  cancelButtonName = "Cancel",
  submitButtonName = "Submit",
  addButtonName,
  method = "POST",
  loaderCaseName = "AddFormModalSpin",
  apiName,
  modalName,
  requestType = "AddRecord",
  recordName,
  extraObj,
  width,
  spinnerName,
}) => {
  const dispatch = useDispatch();
  const crudProps = useSelector((state) => state.CrudR);
  const onSubmit = (value) => {
    
    if (value && value.phoneNumber) {
      value["phoneNumber"] = `+${value.phoneNumber}`;
    }
    let obj = value;
    if (extraObj) {
      obj = { ...value, ...extraObj };
    }
    dispatch(DataRequestAction(method, apiName, obj, requestType, recordName, loaderCaseName, modalName));
  };
  const closeModal = () => {
    form.resetFields();
    dispatch({ type: "Hide_Modal", payload: null, modalName: modalName });
  };
  useEffect(() => {
    if (!crudProps[modalName]) {
      form.resetFields();
    }
  }, [crudProps[modalName]]);
  return (
    <>
      <Button type="primary" onClick={() => dispatch({ type: "Show_Modal", modalName: modalName })}>
        {addButtonName}
      </Button>
      <Modal
        onCancel={() => closeModal()}
        title={modalTitle}
        open={crudProps[modalName]}
        footer={null}
        width={width}
        centered
      >
        <hr className="text-[#D9D9D9] m-0" />

        <Form onFinish={onSubmit} form={form} layout="vertical">
          {children}
          <div className="flex justify-end gap-3 pt-4" style={{ borderTop: "1px solid #DEDEDE" }}>
            <Button className="font-roboto-medium" onClick={() => closeModal()}>
              {cancelButtonName}
            </Button>
            <Button
              loading={spinnerName ? crudProps[spinnerName] : crudProps["addRecordSpin"]}
              disabled={spinnerName ? crudProps[spinnerName] : crudProps["addRecordSpin"]}
              type="primary"
              htmlType="submit"
              className="font-roboto-medium"
            >
              {submitButtonName}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default AddFormModal;
